import * as Atom from 'effect/unstable/reactivity/Atom';

/**
 * How many pages beyond the first the alphabet listing has loaded, keyed by the
 * letter they were loaded for.
 *
 * One shared counter cannot be correct here: browser history moves the alphabet
 * filter without going through `glossaryFilterActionFn`, so nothing resets the
 * count on Back or Forward. A letter whose listing the user had expanded would
 * hand its page count to whatever letter the URL lands on next, requesting
 * pages nobody asked for. Keyed by letter, each listing carries its own count,
 * and returning to one restores the depth it was left at.
 */
// The key is the memoization key `Atom.family` looks the counter up by; the
// counter itself has no use for its value.
//
// `keepAlive` because the listing unmounts the moment the filter changes, and a
// counter disposed with it would reset to 0 — the depth would survive only for
// as long as the user stayed on the letter, which is exactly when it does not
// need to. The pages themselves are already retained (`fetchGlossaryTermsAtom`
// is `keepAlive` too), so restoring the depth costs no new request. One counter
// per letter visited is a bounded handful of integers.
export const glossaryLoadMorePagesAtom = Atom.family((_alphabetFilter: string) =>
  Atom.make(0).pipe(Atom.keepAlive)
);
